export default __webpack_public_path__ + "static/media/custom.ec79ca90.jpg";